/* Initialize Flickity */
let options = {
  prevNextButtons: true,
  pageDots: false,
  draggable: false,
  contain: true,
  cellAlign: 'center',
  adaptiveHeight: true,
  groupCells: 3
};

if ( matchMedia('screen and (min-width: 1140px)').matches ) {
  options.groupCells = 6;
  options.prevNextButtons = false;
}

if ( matchMedia('screen and (max-width: 768px)').matches ) {
  options.groupCells = 1;
}

$('.main-carousel').flickity( options );

/** Sorting on collection page */
$(document).ready(()=> {
  $('.sorting-option').on('click',function() {
    $('#SortBy').val($(this).data('value')).change()
  })
})

/* Show button in blog card on hover */
$(document).ready(()=> {
  $('.blog-post-custom').each(function () {
    ($(this).hover(
      function() {
        $(this).addClass( "blog-card-hover" );
      },
      function() {
        $( this ).removeClass( "blog-card-hover" )
      }
    ))
  })
})
